<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="showFailureMessage">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-if="typeof errors !== 'string'" class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <br/>

        <div class="mb-5" v-if="this.$store.getters.isAdmin">
            <label>Owner:</label>
            <treeselect placeholder="Select User"
                        v-model="link.user"
                        :multiple="false"
                        :options="userList"
                        :load-options="loadUserList"
                        value-format="object"
            />
        </div>
        <div class="mb-5">
            <label>Group:</label>
            <treeselect placeholder="Select Group"
                        v-model="link.group"
                        :multiple="false"
                        :options="groupList"
                        :load-options="loadGroupList"
                        value-format="object"
            />
            <div class="text-danger" v-if="$v.link.group.$error">Group is required.</div>
        </div>
        <div class="form-group">
            <label class="mb-1">URL:</label>
            <small class="form-text text-muted mt-0">
                [uuid] and [junk] macros are available here.
            </small>
            <input v-model="link.url" type="text" class="form-control">
            <div class="text-danger" v-if="$v.link.url.$error">URL is required.</div>
        </div>
        <div class="form-group text-center p-b-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                        v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import LinkService from '../../services/LinkService';
    import LinkGroupService from '../../services/LinkGroupService';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../../services/UserService';

    export default {
        name: 'LinkForm',
        props: ['id'],
        components: {Treeselect},
        data() {
            return {
                link: {
                    id: null,
                    group: null,
                    url: null,
                    user: null
                },
                errors: {},
                showFailureMessage: false,
                userList: null,
                groupList: null,
                submitting: false,
            }
        },
        mounted() {
            if (this.id) {
                LinkService.getLink(this.id).then(response => {
                    this.link = response.data;
                    this.$emit('hidePreloader', false)
                });
            }
        },
        validations: {
            link: {
                group: {required},
                url: {required}
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                if (!this.link.user) {
                    delete this.link.user;
                }

                this.submitting = true;
                let submitMethod = null;
                if (this.id) {
                    submitMethod = LinkService.updateLink(this.id, JSON.stringify(this.link));
                } else {
                    submitMethod = LinkService.createLink(JSON.stringify(this.link));
                }

                submitMethod.then(response => {
                    if ([200, 201].includes(response.status)) {
                        this.$router.push({name: 'links'});
                    }
                    this.submitting = false;
                    this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                    this.showFailureMessage = true;
                });
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            loadGroupList({callback}) {
                LinkGroupService.getGroupSelect().then(response => {
                    this.groupList = response.data['hydra:member'].map(group => {
                        return {id: group.id, label: group.name}
                    });
                    callback();
                });
            }
        }
    }
</script>

<style scoped>

</style>
